import api from "@services/api";
import User from "@models/user";
import router from "@router";

const USER = "@USER";

export const authService = {
  isAuthenticated,
  setToken,
  getUser,
  getRefreshToken,
  getToken,
  hasRole,
  login,
  logout,
  refreshToken
};

function isAuthenticated() {
  var user = JSON.parse(localStorage.getItem(USER));
  if (user && user.token !== null) {
    var expires = new Date((user.expires - 621355968000000000) / 10000);
    var now = new Date();
    now.setMinutes(now.getMinutes() + 10);
    if (expires > now) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function setToken(user) {
  localStorage.setItem(USER, JSON.stringify(user));
}

function getUser() {
  return JSON.parse(localStorage.getItem(USER));
}

function getToken() {
  return getUser()?.token;
}

function getRefreshToken() {
  return getUser()?.refreshToken;
}

function hasRole(roles) {
  return getUser()?.perfil ? roles.includes(getUser().perfil) : false;
}

function login(email, password) {
  return api
    .post(`api/Login`, { email: email, senha: password })
    .then(response => {
      if (response.data["status"].toLowerCase() == "success") {
        var data = response.data["data"];
        var user = new User(
          data.token,
          data.expiration,
          data.refreshToken.token
        );
        setToken(user);
        return user;
      } else {
        throw response;
      }
    })
    .catch(error => {
      throw error;
    });
}

function logout() {
  var token = getRefreshToken();
  if (token) {
    api
      .post(`api/Token/Revoke`, { token: token })
      .then(response => {
        if (response.data["status"].toLowerCase() !== "success") {
          throw response;
        }
      })
      .catch(error => {
        throw error;
      });
  }
  localStorage.removeItem(USER);
  router.push("/Login");
}

async function refreshToken() {
  var token = getRefreshToken();
  if (token) {
    return await api
      .post(`api/Token/Refresh`, { token: token })
      .then(response => {
        if (response.data["status"].toLowerCase() == "success") {
          var data = response.data["data"];
          var user = new User(
            data.token,
            data.expiration,
            data.refreshToken.token
          );
          setToken(user);
          return user;
        } else {
          localStorage.removeItem(USER);
          if (window.location.pathname != "/Login") {
            router.push("/Login");
          }
        }
      })
      .catch(() => {
        localStorage.removeItem(USER);
        if (window.location.pathname != "/Login") {
          router.push("/Login");
        }
      });
  }
}

export default authService;
